<template>
	<tbody>
		<tr class="customtableloading" v-if="type == 'table' && pageloader_value" v-for="n in colspan">
		    <td class="animated-background"  v-for="i in colspan"> 
				<div class="animated-background"></div>
		  	</td>
		</tr>
		<tr  v-if="type == 'table' && list != '' && list.totalRecords == 0 && !pageloader_value">
		    <td class="noRecordFound"  :colspan="colspan"> 
				<img src="../../../../static/fxView/images/search.svg" alt="no record found">
				<p>{{$t('thereIsNoRecord')}}</p>
		  	</td>
		</tr>
		<tr  v-if="type == 'table'  && !pageloader_value && (list == '' || list == null)">
		    <td class="noRecordFound"  :colspan="colspan"> 
				<img src="../../../../static/fxView/images/search.svg" alt="no record found">
				<p>{{$t('thereIsNoRecord')}}</p>
		  	</td>
		</tr>
	</tbody>
</template>
<script>
	import { fxViewMixins } from '@/plugins/fxView'
	export default {
		name: 'LoaderComponent',
		mixins: [fxViewMixins],
		data() {
			return { }
		},
		props:['pageloader_value','type','colspan','list']
	}
</script>


// WEBPACK FOOTER //
// src/components/fxView/shared/loader_component.vue